import React from 'react'
import cx from 'classnames'
import './Typography.scss'

const Heading3 = ({ bold, center, children, className, gray, left, white }) => (
    <h3 className={cx('heading3', className, bold && 'bold', left && 'text-left', white ? 'heading-white' : '', gray ? 'heading-gray' : '', center ? 'text-center' : '')}>{children}</h3>
)

export default Heading3



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Heading3.jsx